import React from 'react';

interface PasteIconProps {
  className?: string;
  onClick: () => void;
  isDarkmode?: boolean;
}

const PasteIcon: React.FunctionComponent<PasteIconProps> = ({
  className,
  onClick,
  isDarkmode = true,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      className={className}
      viewBox="0,0,256,256"
      onClick={onClick}
    >
      <g
        fill={isDarkmode ? '#ffffff' : '#010a23'}
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        strokeDasharray=""
        strokeDashoffset="0"
        fontFamily="none"
        fontWeight="none"
        fontSize="none"
        textAnchor="none"
      >
        <g transform="scale(8.53333,8.53333)">
          <path d="M15,0c-1.64501,0 -3,1.35499 -3,3h-4c-1.64497,0 -3,1.35503 -3,3v18c0,1.64497 1.35503,3 3,3h14c1.64497,0 3,-1.35503 3,-3v-18c0,-1.64497 -1.35503,-3 -3,-3h-4c0,-1.64501 -1.35499,-3 -3,-3zM15,2c0.56413,0 1,0.43587 1,1c0,0.56413 -0.43587,1 -1,1c-0.56413,0 -1,-0.43587 -1,-1c0,-0.56413 0.43587,-1 1,-1zM8,5h4v1c0,0.552 0.448,1 1,1h4c0.552,0 1,-0.448 1,-1v-1h4c0.56503,0 1,0.43497 1,1v18c0,0.56503 -0.43497,1 -1,1h-14c-0.56503,0 -1,-0.43497 -1,-1v-18c0,-0.56503 0.43497,-1 1,-1z"></path>
        </g>
      </g>
    </svg>
  );
};

export default PasteIcon;
